import React from 'react';
import { Checkbox } from '../ui/checkbox.tsx';
import { Label } from '../ui/label.tsx';
import { cn } from '../../lib/utils.ts';

const CheckboxField = ({
  label,
  checked,
  onChange,
  id,
  className = "",
  containerClassName = "",
  disabled = false,
  readOnly = false,
  required = false
}) => {
  const isDisabled = disabled || readOnly;

  return (
    <div className={cn('flex items-center gap-2', containerClassName)}>
      <Checkbox
        id={id}
        checked={checked || false}
        onCheckedChange={(value) => {
          if (readOnly) return;
          onChange(!!value);
        }}
        disabled={isDisabled}
        className={className}
      />
      <Label
        htmlFor={id}
        className={cn('cursor-pointer', isDisabled && 'pointer-events-none opacity-50')}
      >
        {label}
        {required && <span className="text-destructive ml-1">*</span>}
      </Label>
    </div>
  );
};

export default CheckboxField;
